var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChipCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49988 2.39735C4.9397 2.39735 2.0536 5.28345 2.0536 8.84363C2.0536 12.4038 4.9397 15.2899 8.49988 15.2899C12.0601 15.2899 14.9462 12.4038 14.9462 8.84363C14.9462 5.28345 12.0601 2.39735 8.49988 2.39735ZM0.621094 8.84363C0.621094 4.4923 4.14855 0.964844 8.49988 0.964844C12.8512 0.964844 16.3787 4.4923 16.3787 8.84363C16.3787 13.195 12.8512 16.7224 8.49988 16.7224C4.14855 16.7224 0.621094 13.195 0.621094 8.84363Z",
    fill: "#43A047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0536 8.84363C2.0536 5.28345 4.9397 2.39735 8.49988 2.39735C12.0601 2.39735 14.9462 5.28345 14.9462 8.84363C14.9462 12.4038 12.0601 15.2899 8.49988 15.2899C4.9397 15.2899 2.0536 12.4038 2.0536 8.84363Z",
    fill: "#43A047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7571 7.01568L7.37882 12.394H6.68736L4.24268 9.9493L4.93414 9.25784L7.03309 11.3568L12.0657 6.32422L12.7571 7.01568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_4350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.84375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipCheck);
export default __webpack_public_path__ + "static/media/chip_check.87a5ffbf9840323ac368c723155dec62.svg";
export { ForwardRef as ReactComponent };